export default "/images/17b6c1bfcf91b9dbc457919de195e0cc.avif";